import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/project-types.tsx';

export const useIsCurrentProjectJiraSoftware = () => {
	const { data: projectContextData, loading } = useProjectContext();
	const isCurrentProjectJiraSoftware = projectContextData?.projectType === SOFTWARE_PROJECT;

	return {
		loading,
		isCurrentProjectJiraSoftware,
	};
};
